import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";

export default function OrthoCareLXPage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/ortho-care-lx/Ortho-Care-lx-n-04.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care-lx/Ortho-Care-lx-n-01.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care-lx/Ortho-Care-lx-n-02.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care-lx/Ortho-Care-lx-n-03.png",
    ],
    productName: "Ortho Care LX",
    productLogo:
      "https://eclipsemattress.in/assets/images/products/ortho-care-lx/ortho-care-lx-logo.png",
    descriptionTitle: "",
    descriptionText:
      "Envisioned to provide plush comfort to every sleeper, Ortho Care LX by Eclipse is a perfect combination of rebonded foam, custom made Eclipse high-density foam and Euro-top. It is a result of century-old research and development. Manufactured with high-density PUF, it extends enhanced lumbar (lower back) support at an economical price.",
    category: { title: "Serene Series", link: "/serene-series/" },
    points: [
      "Result of extensive R&D over a century",
      "High-density Orthobond foam core with customized Eclipse plush foam",
      "Unique border design",
      "Enhanced lower back support",
      "Works on pressure points for complete relief",
    ],

    featuresText: [
      "Eclipse HD Plush Foam",
      "Eclipse Pure HD Foam",
      "Eclipse Orthobond Foam",
    ],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/ortho-care-lx/Ortho-Care-lx-n-06.png",

    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/ortho-care-lx/Ortho-Care-lx-n-07.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care-lx/Ortho-Care-lx-n-08.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care-lx/Ortho-Care-lx-n-09.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care-lx/Ortho-Care-lx-n-10.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care-lx/Ortho-Care-lx-n-11.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/ortho-care-lx/Ortho-Care-lx-n-05.png",
    price: "14,799 - ₹52,799",
    brochureLink:
      "https://eclipsemattress.in/assets/pdfs/Patent-&-Luxury-Catalogue.pdf",

    relatedProducts: [
      {
        title: "Ortho Visco LX",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/ortho-visco-lx.jpg",
        link: "/luxury-collection/ortho-visco-lx/",
      },
      {
        title: "Harmony Ortho",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/harmonyortho.jpg",
        link: "/harmony-collection/harmony-ortho/",
      },
      {
        title: "Ortho Latex LX",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/ortho-latex-lx.jpg",
        link: "/luxury-collection/ortho-latex-lx/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Buy Best Ortho Mattress | Eclipse International"
        description="Ortho care mattress provides plush comfort to every sleeper, perfect combination of rebonded foam, custom made Eclipse high-density foam and Euro-top. Extends lower back support at an economical price. Economically priced to fit your budget."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-orthocarelx.jpg"
      />
      <Productpage product={data} location={location} />
    </div>
  );
}
